const Section5 = new function() {
    this.init = () => {
        if (!document.querySelector('.sn-section--5')) return;

        const infoElements = document.querySelectorAll('.sn-section--5 .sn-card__text');
        const triggers = document.querySelectorAll('.sn-fake-card');
        const scroller = document.querySelector('#sn-page') || document.body

        triggers.forEach((trigger, index) => {
            ScrollTrigger.create({
            trigger: trigger,
            start: 'top center',
            end: 'bottom center',
            onEnter: () => activateInfo(index),
            onEnterBack: () => activateInfo(index),
            scroller,
            // markers: true,
            });
        });

        function activateInfo(index) {
            infoElements.forEach((el, i) => {
            el.classList.toggle('active', i === index);
            });
        }
    }
}

export default Section5;